export const USER_ROLES = {
  Anonymous: "anonymous",
  Member: "member",
  Staff: "staff",
  Agent: "agent",
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const roles = ["WWWM", "EMPL"];

export const isAadvantageExcludedRole = (isStaff?: boolean): boolean => Boolean(isStaff);

export const ANONYMOUS_USER_ROLE_CODE = "WWWA";
export const WEB_ANONYMOUS_AGENT_CODE = "WebAnonymous";
